<template>
  <div class="mod-overlay">
    <div class="mod-modal banco-modal">
      <div class="mod-modal-header">
        <h3 class="mod-modal-title">
          <i :class="isEdit ? 'bi bi-pencil' : 'bi bi-plus-circle'"></i>
          {{ isEdit ? 'Editar banco' : 'Nuevo banco' }}
        </h3>
        <button class="mod-modal-close" @click="$emit('close')">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <form class="mod-modal-body" @submit.prevent="handleSubmit">
        <div v-if="error" class="mod-alert-error">
          <i class="bi bi-exclamation-triangle-fill"></i>
          {{ error }}
        </div>

        <div class="mod-form-grid">
          <div class="mod-field">
            <label for="Clave">Clave <span class="mod-required">*</span></label>
            <input id="Clave" v-model="form.Clave" type="text" :disabled="isEdit" required maxlength="50" placeholder="BBVA">
          </div>
          <div class="mod-field">
            <label for="Nombre">Nombre <span class="mod-required">*</span></label>
            <input id="Nombre" v-model="form.Nombre" type="text" required maxlength="120" placeholder="BBVA">
          </div>
          <div class="mod-field">
            <label for="CodigoBanco">Código bancario</label>
            <input id="CodigoBanco" v-model="form.CodigoBanco" type="text" maxlength="20" placeholder="012">
          </div>
          <div class="mod-field">
            <label for="NombreCompleto">Nombre completo</label>
            <input id="NombreCompleto" v-model="form.NombreCompleto" type="text" maxlength="180" placeholder="BBVA México, S.A.">
          </div>
          <div class="mod-field">
            <label for="Pais">País</label>
            <input id="Pais" v-model="form.Pais" type="text" maxlength="80" placeholder="MEX">
          </div>
          <div class="mod-field">
            <label for="Moneda">Moneda</label>
            <input id="Moneda" v-model="form.Moneda" type="text" maxlength="10" placeholder="MXN">
          </div>
          <div class="mod-field">
            <label for="SwiftBic">SWIFT/BIC</label>
            <input id="SwiftBic" v-model="form.SwiftBic" type="text" maxlength="20" placeholder="BCMRMXMM">
          </div>
          <div class="mod-field">
            <label for="AbaRouting">ABA/Routing</label>
            <input id="AbaRouting" v-model="form.AbaRouting" type="text" maxlength="20" placeholder="Solo bancos que lo usen">
          </div>
          <div class="mod-field">
            <label for="ClaveErp">Clave ERP</label>
            <input id="ClaveErp" v-model="form.ClaveErp" type="text" maxlength="50" placeholder="Clave en sistema externo">
          </div>
          <div class="mod-field">
            <label for="SitioWeb">Sitio web</label>
            <input id="SitioWeb" v-model="form.SitioWeb" type="url" maxlength="180" placeholder="https://...">
          </div>
          <div class="mod-field">
            <label for="Telefono">Teléfono</label>
            <input id="Telefono" v-model="form.Telefono" type="text" maxlength="40" placeholder="Teléfono de contacto">
          </div>
          <div class="mod-field">
            <label for="Orden">Orden</label>
            <input id="Orden" v-model.number="form.Orden" type="number" min="0">
          </div>
          <div class="mod-field mod-field-check">
            <label class="mod-check-label">
              <input v-model="form.EsActivo" type="checkbox">
              <span>Activo</span>
            </label>
          </div>
          <div class="mod-field banco-wide">
            <label for="Observaciones">Observaciones</label>
            <input id="Observaciones" v-model="form.Observaciones" type="text" maxlength="255" placeholder="Notas internas para este banco">
          </div>
        </div>

        <div class="mod-modal-footer">
          <button type="button" class="mod-btn mod-btn-cancel" @click="$emit('close')">Cancelar</button>
          <button type="submit" class="mod-btn mod-btn-save" :disabled="saving">
            <span v-if="saving" class="mod-spinner-sm"></span>
            <template v-else>
              <i class="bi bi-check-lg"></i>
              {{ isEdit ? 'Guardar cambios' : 'Crear banco' }}
            </template>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import authService from '@/services/auth';
import { showToast } from '@/shared/utils/toast';
import { createBanco } from './banco.model';
import bancoService from './banco.service';

export default {
  name: 'BancoForm',
  props: {
    item: { type: Object, default: null },
    isEdit: { type: Boolean, default: false }
  },
  emits: ['saved', 'close'],
  data() {
    return {
      form: createBanco(),
      saving: false,
      error: null
    };
  },
  created() {
    if (this.isEdit && this.item) this.form = { ...this.item };
    else {
      const empresa = authService.getSelectedEmpresa();
      this.form.EmpresaId = empresa?.EmpresaId || 0;
    }
  },
  methods: {
    async handleSubmit() {
      this.saving = true;
      this.error = null;
      if (!this.form.Clave || !this.form.Nombre) {
        this.error = 'Clave y Nombre son obligatorios';
        this.saving = false;
        return;
      }
      try {
        const result = await bancoService.guardar({
          ...this.form,
          Clave: String(this.form.Clave || '').trim().toUpperCase()
        });
        if (result.Number >= 0) {
          showToast(result.Message || 'Guardado correctamente', result.Type || 'success');
          this.$emit('saved');
        } else {
          this.error = result.Message || 'Error al guardar';
        }
      } catch {
        this.error = 'Error de conexión con el servidor';
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped>
@import "@/modules/_shared/catalog.css";

.banco-modal {
  max-width: 920px;
}

.banco-wide {
  grid-column: span 2;
}
</style>
